/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type EvalScheduleDeletedObject = {
  id: string;
  object: "eval.schedule.deleted";
  deleted: boolean;
};

/** @internal */
export const EvalScheduleDeletedObject$inboundSchema: z.ZodType<
  EvalScheduleDeletedObject,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  object: z.literal("eval.schedule.deleted"),
  deleted: z.boolean(),
});
/** @internal */
export type EvalScheduleDeletedObject$Outbound = {
  id: string;
  object: "eval.schedule.deleted";
  deleted: boolean;
};

/** @internal */
export const EvalScheduleDeletedObject$outboundSchema: z.ZodType<
  EvalScheduleDeletedObject$Outbound,
  z.ZodTypeDef,
  EvalScheduleDeletedObject
> = z.object({
  id: z.string(),
  object: z.literal("eval.schedule.deleted"),
  deleted: z.boolean(),
});

export function evalScheduleDeletedObjectToJSON(
  evalScheduleDeletedObject: EvalScheduleDeletedObject,
): string {
  return JSON.stringify(
    EvalScheduleDeletedObject$outboundSchema.parse(evalScheduleDeletedObject),
  );
}
export function evalScheduleDeletedObjectFromJSON(
  jsonString: string,
): SafeParseResult<EvalScheduleDeletedObject, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EvalScheduleDeletedObject$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EvalScheduleDeletedObject' from JSON`,
  );
}
